<template>
  <modal-template :id="id" :name="name" :showModal="showModal" v-on:hide-modal="close()">
    <template slot="modalContent">
      <v-tabs v-model="activeTab" grow>
        <v-tab key="criteria" ripple>Criteria</v-tab>
        <v-tab key="actions" ripple>Actions</v-tab>

        <v-tab-item key="criteria">
          <div id="subheader">
            <v-data-table id="criteria-table" :items="criteria" hide-actions class="elevation-5">
              <template slot="no-data"><tr><td colspan="100%" class="text-xs-center">Empty</td></tr></template>
              <template slot="headers" slot-scope="props">
                <th class="text-xs-left" style="width: 50px;">Order by</th>
                <th class="text-xs-left" style="width: 40%">Name</th>
                <th class="text-xs-left column-wrap">Type</th>
                <th class="text-xs-left column-wrap">Direction</th>
                <th style="width: 70px;"></th>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-radio-group v-model="orderByCriterion" name="rowSelector"><v-radio :value="props.item" ripple/></v-radio-group>
                </td>
                <td>
                  <v-text-field placeholder="Insert value" v-model="props.item['Name']" hide-details></v-text-field>
                </td>
                <td>
                  <v-select placeholder="Please Select" :items="['Text', 'Number']" v-model="props.item['Type']" hide-details>
                    {{ props.item['Type'] }}
                  </v-select>
                </td>
                <td>
                  <v-select placeholder="Please Select" :items="['Ascendant', 'Descendant']" v-model="props.item['Direction']" hide-details>
                    {{ props.item['Direction'] }}
                  </v-select>
                </td>
                <td><v-btn icon @click="removeCriteriaLine(props.item)"><v-icon color="pink">delete</v-icon></v-btn></td>
              </template>
            </v-data-table>
            <v-btn @click="addCriteriaLine()" color="info">New Criterion</v-btn>
          </div>
        </v-tab-item>

        <v-tab-item key="actions">
          <div id="subheader">
            <v-data-table id="actions-table" :items="actions" hide-actions class="elevation-5">
              <template slot="no-data"><tr><td colspan="100%" class="text-xs-center">Empty</td></tr></template>
              <template slot="headers" slot-scope="props">
                <th class="text-xs-left" style="width: 40%">Name</th>
                <th class="text-xs-left column-wrap" v-for="crit in criteria" :key="crit['Name']">{{ crit['Name'] }}</th>
                <th style="width: 70px;"></th>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-text-field placeholder="Insert value" v-model="props.item['Name']" hide-details></v-text-field>
                </td>
                <td v-for="crit in criteria" :key="crit['Name']">
                  <v-text-field placeholder="Insert value" v-model="props.item[crit['Name']]" :type="crit['Type'] ? crit['Type'].toLowerCase() : 'text'" hide-details></v-text-field>
                </td>
                <td><v-btn icon @click="removeActionsLine(props.item)"><v-icon color="pink">delete</v-icon></v-btn></td>
              </template>
            </v-data-table>
            <v-btn @click="addActionsLine()" color="info">New Action</v-btn>
          </div>
        </v-tab-item>
      </v-tabs>
    </template>
  </modal-template>
</template>

<script>
import {EventBus} from '@/event-bus.js'
import ModalTemplate from '@/components/Workspace/Methods/ModalTemplate'
export default {
  components: {
    ModalTemplate,
  },
  data: () => ({
    showModal: false,
    activeTab: null,
    tabs: ['criteria', 'actions'],

    criteria: [],
    actions: [],

    dirty: {},
    dataFromConnection: false,
    orderByCriterion: null,
  }),
  props: {
    id: String,
    name: String
  },
  methods: {
    clone(object) {
      return JSON.parse(JSON.stringify(object))
    },
    saveModuleData() {
      var headers = ['Name'];
      this.criteria.forEach(function(crit) {
        headers.push(crit['Name']);
      });
      var direction = this.orderByCriterion ? this.orderByCriterion['Direction'] : '';
      var name = this.orderByCriterion ? this.orderByCriterion['Name'] : '';
      var methodAttributes = {};
      methodAttributes.input = {
        criteria: this.criteria,
        actions: this.actions,
        orderByCriterion: this.orderByCriterion
      };
      methodAttributes.output = {
        headers: headers,
        description: "Ordered by criterion '" + name + "' in '" + direction + "' direction"
      };
      methodAttributes.id = this.id;
      EventBus.$emit('save-module-data', methodAttributes);
    },
    setPropertyFromInputFile(mod) {
      if(mod.newConnection) this.dataFromConnection = true;
      this[mod.property] = this.clone(mod.value);
      this.saveModuleData();
      if(mod.newConnection) this.dataFromConnection = false;
    },
    checkIfDirty(prop) {
      if(!this.dirty[prop]) {
        this.dirty[prop] = true;
        var offset = this.tabs.indexOf(prop);
        var obj = {target: this.id, property: prop, value: this[prop], yOffset: offset};
        EventBus.$emit('generate-data-module', obj);
        return true;
      } else return false;
    },
    addCriteriaLine() {
      this.criteria.push({'Name': '', 'Type': '', 'Direction': ''});
      if(!this.dataFromConnection) this.checkIfDirty('criteria');
    },
    removeCriteriaLine(line) {
      var index = this.criteria.indexOf(line);
      if(index > -1) {
        if(this.orderByCriterion === line['Name'])
          this.orderByCriterion = null;
        this.criteria.splice(index, 1);
      }
    },
    addActionsLine() {
      this.actions.push({'Name': ''});
      if(!this.dataFromConnection) this.checkIfDirty('actions');
    },
    removeActionsLine(line) {
      var index = this.actions.indexOf(line);
      if(index > -1)
        this.actions.splice(index, 1);
    },
    close () {
      this.saveModuleData();
      this.showModal=false;
    }
  },
  mounted: function () {
    EventBus.$on('show-modal-'+this.id, tab => {
      this.showModal = true;
      var tabId = this.tabs.indexOf(tab);
      if(tabId!==-1) this.activeTab = tabId;
    });
    EventBus.$on('update-module-'+this.id, mod => {
      this.setPropertyFromInputFile(mod);
    });
    this.saveModuleData();
  }
}
</script>

<style scoped>
  #subheader {
    margin: 20px;
    font-size: 30px;
    line-height: 1.5;
  }
  * {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 10px
  }
  table.v-table thead th {
    background-color: #f2f2f2;
    max-width: 150px;
    white-space: initial;
    word-wrap: break-word;
    color: #333333 !important;
    font-size: 13px;
    font-weight: bold;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
    border-bottom: 1px solid LightGray;
  }
  table.v-table tbody td {
    font-family: 'Roboto Mono', sans-serif !important;
    word-wrap: break-word;
    font-size: 12px;
    font-weight: normal;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
  }
  .v-input {
    font-size: 12px;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
  .column-wrap {
    width: 1px;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/Workspace/Methods/OrderByModal.vue